import React, { FC, useState } from 'react';
import { EnvKey, MapNavigationPill } from '@/src/components/UI/HouseDetail/MapViewSection';
import MapPageProps from '@/src/components/UI/MapContainerType';
import FullPage from '@/src/components/UI/FullPage';
import Image from 'next/image';
import { Stack } from '@chakra-ui/react';
import Link from 'next/link';
import dynamic from 'next/dynamic';

const MapView = dynamic(() => import('@/src/components/UI/Map/MapView'), {
  ssr: false,
});
const MapContainer: FC<MapPageProps> = ({ detailData }) => {
  const [selectedPill, setSelectedPill] = useState<EnvKey>('traffic');
  return (
    <FullPage title={'地圖'} hasPadding={false} hasHeaderPlaceHolder>
      <div className={`flex h-screen w-screen`}>
        <MapView
          center={{
            lat: parseFloat(detailData!.location_latitude!),
            lng: parseFloat(detailData!.location_longitude!),
          }}
          //@ts-ignore
          markers={detailData[`traffic_env_${selectedPill}`]}
        />
        <Link passHref href={`/buy/${detailData.sid}/street`}>
          <Stack w={'35%'} position={'fixed'} right={4} bottom={10}>
            <Image width={360} height={270} layout={'responsive'} src={'/street.png'} priority />
          </Stack>
        </Link>
        <div className={'fixed top-15 left-0 w-screen bg-white'}>
          <MapNavigationPill
            country={detailData.country!}
            selectedPill={selectedPill}
            onSelect={(value) => setSelectedPill(value)}
          />
        </div>
      </div>
    </FullPage>
  );
};
export default MapContainer;
